export default function Header() {
  return (
    <div className="flex pt-4">
      <h2 className="font-sans font-bold text-white pl-4">proofin.bio</h2>
    </div>
  )
}